import { Link } from 'react-router-dom'
import { DashboardProps } from '../../interfaces/dashboard'

const DashboardCard = ({
  icon,
  bgColor,
  cardBg,
  title,
  subtitle,
  value,
  trendText,
  trendColor,
  trendIcon,
  isProfileCard = false,
  profileImg,
  actionText,
  actionIcon,
}: DashboardProps) => {
  return (
    <div className={`p-2.5 rounded-lg space-y-5 w-[269px] h-fit ${cardBg}`}>
      <div className="flex space-x-1.5">
        <div
          className={`p-2.5 rounded-[10px] flex items-center justify-center w-11 h-11 ${bgColor}`}
        >
          <img src={icon} alt={title} />
        </div>
        <div>
          <p className="font-medium">{title}</p>
          <p className="font-[13px] text-[#6C757D]truncate overflow-hidden whitespace-nowrap">{subtitle}</p>
        </div>
      </div>
      {isProfileCard ? (
        <div className="flex items-center space-x-2.5">
          <div className="h-6 w-6 rounded-lg">
            <img src={profileImg} alt="profile" />
          </div>
          <Link className="flex space-x-1 items-center" to={'/staffs'}>
            <p className="font-medium w-fit truncate">
              {actionText}
            </p>
            <img src={actionIcon} alt="arrow" />
          </Link>
        </div>
      ) : (
        <div className="flex space-x-2.5">
          <p className="text-[#343A40] font-medium">{value}</p>
          <div className={`flex space-x-1 items-center ${trendColor}`}>
            <p className="text-[13px]">{trendText}</p>
            <img src={trendIcon} alt="trend" />
          </div>
        </div>
      )}
    </div>
  )
}

export default DashboardCard
